import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, toHandlers as _toHandlers } from "vue"

const _hoisted_1 = {
  "aria-label": "card",
  class: "map-card"
}
const _hoisted_2 = {
  key: 0,
  class: "emb-card_body"
}
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = {
  key: 0,
  class: "ammenity-title"
}
const _hoisted_5 = {
  key: 0,
  class: "tab"
}
const _hoisted_6 = {
  key: 0,
  class: "ammenity-imginfo"
}
const _hoisted_7 = {
  key: 0,
  class: "carousel-navigation"
}
const _hoisted_8 = {
  key: 1,
  class: "content-bottom"
}
const _hoisted_9 = {
  key: 0,
  class: "ammenity-next"
}
const _hoisted_10 = { class: "ammenity-next-link" }
const _hoisted_11 = { class: "ammenity-next-icon" }

import { isMobile, isTablet } from 'mobile-device-detect';
import LazyImage from './../LazyImage.vue';
import { apiFetchAminityInfo } from '../../api';
import { LotPosition, AmenityInfo, Amenity } from './../../types';
import LeftArrowIcon from '@/assets/icons/LeftArrow.vue';
import lodash from 'lodash';
import {
  addImageScaler,
  calcZoom,
  getPlatMapModalPosition,
  getPlatMapModalPositionMobile,
  getTouchesCenter,
  getZoomDistance,
} from './../../core';
import {
  computed,
  nextTick,
  onMounted,
  onUnmounted,
  onUpdated,
  Ref,
  ref,
  toRefs,
  watch,
} from 'vue';
import { Carousel, Navigation, Slide } from 'vue3-carousel';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlatmapAmenityModal',
  props: {
    position: {},
    amenityId: {},
    underlay: { type: Boolean },
    amenities: {},
    allAmenities: {},
    isKioskMode: { type: Boolean },
    zoomLevel: {}
  },
  emits: [
  'closeAmenityInfo',
  'updateLotPosition',
  'setAminityId',
  'setMapCenter',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const {
  position,
  amenityId,
  underlay,
  amenities,
  allAmenities,
  isKioskMode,
  zoomLevel,
} = toRefs(props);
const emits = __emit;

const sliderOptions: any = {
  slidesToShow: 1,
  infinite: false,
};
const amenityTitle = ref('');
const amenityCaption = ref('');
const hasMobile = !!(isMobile && !isTablet);
const hasTablet = isTablet;
const amenityInfo: any = ref({});
const loading = ref(true);
const lotPosition = ref({} as any);
const nextAmenityName = ref('');
const baseElement = ref(null as any);
const slick = ref(null as any);

const zoom = ref(1);
const zoomCenter = ref({
  x: 0,
  y: 0,
});
const lastDistance = ref(0);
const minZoomBounce = ref(0.015);
const maxZoomBounce = ref(0.015);
const width = ref(window.innerWidth);
const height = ref(window.innerHeight);
const lastX = ref(null as any);
const lastY = ref(null as any);
const x = ref(0);
const y = ref(0);
const transition = ref({
  transform: null as any,
  origin: 'transform-origin 400ms linear' as any,
});
const minZoom = ref(1);
const maxZoom = ref(10);
const speed = ref(0.5);

const closeAmenityInfo = () => {
  emits('closeAmenityInfo');
};

const updateLotPosition = (lotPosition: LotPosition) => {
  emits('updateLotPosition', lotPosition);
};
const setAminityId = (amenityId: string) => {
  emits('setAminityId', amenityId);
};
const setMapCenter = (x: number, y: number) => {
  emits('setMapCenter', x, y);
};

watch(amenityId, (val: string, oldVal: string) => {
  if (val !== oldVal) {
    resetZoom();
    fetchAmenityInfo(val);
  }
});

watch(position, (val: LotPosition, oldVal: LotPosition) => {
  if (!lodash.isEqual(val, oldVal)) {
    lotPosition.value = val;
  }
});

onMounted(() => {
  lotPosition.value = position.value;
  fetchAmenityInfo(amenityId.value);
});

const handleReInit = () => {
  nextTick(() => {
    slick.value.reSlick();
  });
};

const beforeAmenityClose = () => {
  amenityInfo.value = {} as AmenityInfo;
  let timer = setTimeout((_) => {
    closeAmenityInfo();
    clearTimeout(timer);
  }, 10);
};

onUpdated(() => {
  nextTick(function () {
    // if (!isMobile && !isTablet)
    updateModalPosition();
  });
});

onUnmounted(() => {
  const el = baseElement.value;
  if (el) {
    el.removeEventListener('touchstart', start);
    el.removeEventListener('touchmove', move);
    el.removeEventListener('touchend', end);
  }
});

const bottomArrowCondition = (xPosition: string, yPosition: string) => {
  return (
    !lodash.isEmpty(lotPosition.value) &&
    !!(
      lotPosition.value.xPosition === xPosition &&
      lotPosition.value.yPosition === yPosition
    )
  );
};

const loadNextAmenityName = () => {
  let currentIndex = amenities.value.indexOf(amenityId.value);
  const nextIndex = ++currentIndex % amenities.value.length;
  const amenityIdData = amenities.value[nextIndex];
  const nextAminity = allAmenities.value.filter((x) => x.id === amenityIdData);
  if (nextAminity.length) nextAmenityName.value = nextAminity[0].title;
  else nextAmenityName.value = '';
};

const loadNewAmenity = () => {
  let currentIndex = amenities.value.indexOf(amenityId.value);
  const nextIndex = ++currentIndex % amenities.value.length;
  const amenityIdData = amenities.value[nextIndex];
  if (underlay.value) {
    movePlatmapWithMap(amenityIdData);
  } else {
    movePlatmapWithoutMap(amenityIdData);
  }
  setAminityId(amenityIdData);
};

const movePlatmapWithoutMap = (amenityId: string) => {
  const amenityElement = document.getElementById(amenityId) as HTMLElement;
  if (amenityElement) {
    const amenityElementPosition = amenityElement.getBoundingClientRect();
    const modalWidth = 364;
    let overlayContainer = document.getElementById('plan-svg') as HTMLElement;
    const containerTop = parseFloat(
      overlayContainer.style.top.replace('px', '')
    );
    const containerLeft = parseFloat(
      overlayContainer.style.left.replace('px', '')
    );
    const topPosition = -(
      amenityElementPosition.y -
      (containerTop + window.innerHeight / 2)
    );
    let leftPosition = -(amenityElementPosition.x - containerLeft);
    if (isMobile) {
      if (leftPosition < window.innerWidth / 2) {
        leftPosition += window.innerWidth / 2;
      }
      if (leftPosition > window.innerWidth) {
        leftPosition = window.innerWidth;
      }
    } else {
      if (leftPosition < window.innerWidth / 2 + modalWidth) {
        leftPosition += window.innerWidth / 2 + modalWidth;
      }
      if (leftPosition > window.innerWidth) {
        leftPosition = window.innerWidth;
      }
    }

    overlayContainer.style.left = `${leftPosition}px`;
    overlayContainer.style.top = `${topPosition}px`;
  }
};

const movePlatmapWithMap = (amenityId: string) => {
  const amenityElement = document.getElementById(amenityId) as HTMLElement;
  if (amenityElement) {
    const amenityElementPosition = amenityElement.getBoundingClientRect();
    setMapCenter(amenityElementPosition.x, amenityElementPosition.y);
  }
};

const updateModalPosition = () => {
  let lotElement = document.getElementById(amenityId.value) as HTMLElement;
  if (lotElement) {
    const modelContainer = document.getElementById(
      'amenity-modal'
    ) as HTMLElement;
    let elementPosition = lotElement.getBoundingClientRect();
    const lotPositionData =
      isMobile || isTablet
        ? getPlatMapModalPositionMobile(elementPosition)
        : getPlatMapModalPosition(
            elementPosition,
            modelContainer.clientHeight,
            zoomLevel.value
          );
    if (!lodash.isEqual(lotPosition.value, lotPositionData)) {
      updateLotPosition(lotPositionData);
    }
  }
};

const resetAmenityInfo = () => {
  amenityTitle.value = '';
  amenityCaption.value = '';
  amenityInfo.value = {} as AmenityInfo;
};

const setAmenityTitleAndCaption = () => {
  for (const [key, value] of Object.entries(amenityInfo.value as AmenityInfo)) {
    if (!amenityTitle.value && value.title) amenityTitle.value = value.title;
    if (!amenityCaption.value && value.caption)
      amenityCaption.value = value.caption;
  }
};

const addScaler = (url) => {
  return addImageScaler(url);
};

const fetchAmenityInfo = async (amenityId: string) => {
  try {
    resetAmenityInfo();
    const data = await apiFetchAminityInfo(amenityId);
    const { result } = data;
    if (result.length) {
      amenityInfo.value = result as AmenityInfo;
      setAmenityTitleAndCaption();
    }
    loadNextAmenityName();
    loading.value = false;
  } catch (error) {
    amenityInfo.value = {} as AmenityInfo;
    loading.value = false;
  }
};

const start = (event) => {
  // event.preventDefault();
  if (event.touches.length === 2) {
    handlePinchStart(event);
  }
};

const handlePinchStart = (event) => {
  const { x, y } = getTouchCenter(
    getTouchesCenter(event.touches[0], event.touches[1])
  );
  if (zoom.value < maxZoom.value) {
    zoomCenter.value.x = x;
    zoomCenter.value.y = y;
  }
  lastDistance.value = getZoomDistance(event.touches[0], event.touches[1]);
};

const getTouchCenter = ({ x, y }) => {
  const rect = baseElement.value.getBoundingClientRect();
  return {
    x: x - rect.left,
    y: y - rect.top,
  };
};

const move = (event) => {
  // event.preventDefault();
  if (event.touches.length === 2) {
    handlePinchMove(event);
  } else {
    handlePanMove(event);
  }
};

const handlePinchMove = (event) => {
  let zoom = getZoomDistance(event.touches[0], event.touches[1]);
  const last = zoom / lastDistance.value;
  const scale = calcZoom(
    minZoom.value - minZoomBounce.value,
    maxZoom.value + maxZoomBounce.value,
    zoom * last
  );
  if (zoom < maxZoom.value || (zoom >= maxZoom.value && scale < zoom)) {
    zoom = scale;
  }
  lastDistance.value = zoom;
};

const handlePanMove = (event) => {
  if (zoom.value > 1) {
    const touch = event.touches[0];
    const x = touch.clientX;
    const y = touch.clientY;
    if (!lastX.value || !lastY.value) {
      lastX.value = x;
      lastY.value = y;
      return null;
    } else {
      const rect = baseElement.value.getBoundingClientRect();
      let diffX = (x - lastX.value) * speed.value;
      let diffY = (y - lastY.value) * speed.value;
      transition.value.transform = null;
      //apply transform
      x.value += diffX;
      y.value += diffY;
      //bounds
      if (rect.left > 0 && diffX > 0) {
        x.value -= diffX;
      }
      if (rect.right < width.value && diffX < 0) {
        x.value -= diffX;
      }
      if (rect.top > 0 && diffY > 0) {
        y.value -= diffY;
      }
      if (rect.bottom < height.value && diffY < 0) {
        y.value -= diffY;
      }
      //to calc the next move
      lastX.value = x;
      lastY.value = y;
    }
  }
};

const end = (event) => {
  // event.preventDefault();
  if (zoom.value <= minZoom.value) {
    resetZoom();
  } else {
    lastX.value = 0;
    lastY.value = 0;
  }
};

const resetZoom = () => {
  zoom.value = 1;
  zoomCenter.value.x = 0;
  zoomCenter.value.y = 0;
  x.value = 0;
  y.value = 0;
};

const zoomStyles = () => {
  let transitionData = '';
  if (transition.value.transform) transitionData += transition.value.transform;
  if (transition.value.origin)
    transitionData +=
      (transitionData.length > 0 ? ', ' : '') + transition.value.origin;
  return {
    transform: `scale(${zoom.value}) translate3d(${x.value}px, ${y.value}px, 0px)`,
    transitionData,
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    id: "amenity-modal",
    class: "embinfobox elem-modal basic",
    style: [
      !_unref(lodash).isEmpty(lotPosition.value)
        ? {
            top: `${lotPosition.value.top}px`,
            left: `${
              _unref(zoomLevel) > 19 || hasMobile
                ? lotPosition.value.left
                : lotPosition.value.left + 25
            }px`,
          }
        : {},
      ,
      zoomStyles,
    ],
    ref_key: "baseElement",
    ref: baseElement
  }, _toHandlers(
      _unref(isKioskMode) ? { touchstart: start, touchmove: move, touchend: end } : {}
    , true)), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("i", {
        "aria-label": "close icon",
        class: "emb_closeicon",
        onClick: beforeAmenityClose
      }),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (amenityTitle.value)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(amenityTitle.value), 1))
                : _createCommentVNode("", true),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "ammenity-site-address" }, "Community feature", -1))
            ]),
            _createElementVNode("div", null, [
              (
              !!amenityInfo.value.length &&
              !amenityInfo.value.every((info) => !info.image_url)
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: "tab-slider",
                      style: _normalizeStyle({ display: loading.value ? 'none' : '' })
                    }, [
                      _createVNode(_unref(Carousel), _mergeProps({
                        ref_key: "slick",
                        ref: slick
                      }, sliderOptions), {
                        addons: _withCtx(() => [
                          (amenityInfo.value.length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(_unref(Navigation))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(amenityInfo.value, (amenityInfoImage) => {
                            return (_openBlock(), _createBlock(_unref(Slide), {
                              key: amenityInfoImage.seq_position
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(LazyImage, {
                                    src: addScaler(amenityInfoImage.image_url),
                                    alt: amenityInfoImage.caption,
                                    isNeighborhoodImage: false
                                  }, null, 8, ["src", "alt"]),
                                  (amenityInfoImage.caption)
                                    ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(amenityInfoImage.caption), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 16)
                    ], 4)
                  ]))
                : (amenityCaption.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(amenityCaption.value), 1))
                  : _createCommentVNode("", true)
            ]),
            (_unref(amenities).length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("span", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (loadNewAmenity()))
                  }, [
                    _cache[2] || (_cache[2] = _createTextVNode(" Next feature: ", -1)),
                    _createElementVNode("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(nextAmenityName.value) + " ", 1),
                      _createElementVNode("i", _hoisted_11, [
                        _createVNode(LeftArrowIcon, { class: "rotate-180" })
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (bottomArrowCondition(`left`, `top`))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({ top: `${lotPosition.value.arrowPosition}px` }),
          class: "arrow-pointer arrow-top-left"
        }, null, 4))
      : _createCommentVNode("", true),
    (bottomArrowCondition(`right`, `top`))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({ top: `${lotPosition.value.arrowPosition}px` }),
          class: "arrow-pointer arrow-top-right"
        }, null, 4))
      : _createCommentVNode("", true),
    (bottomArrowCondition(`left`, `bottom`))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          style: _normalizeStyle({ top: `${lotPosition.value.arrowPosition}px` }),
          class: "arrow-pointer arrow-bottom-left"
        }, null, 4))
      : _createCommentVNode("", true),
    (bottomArrowCondition(`right`, `bottom`))
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          style: _normalizeStyle({ top: `${lotPosition.value.arrowPosition}px` }),
          class: "arrow-pointer arrow-bottom-right"
        }, null, 4))
      : _createCommentVNode("", true)
  ], 16))
}
}

})